import { Text } from '@beat-venues/ui/subset';
import type { CommonProps } from '../../types';
import { tv, type VariantProps } from 'tailwind-variants';
import { Button, Like } from '../../atoms';
import { getCookie } from 'cookies-next';
import { useState } from 'react';
import { Modal } from '../modal';
import { useTranslation } from 'react-i18next';

export interface FavoriteGenreProps
    extends CommonProps,
        VariantProps<typeof FavoriteGenreStyles> {
    id: string;
    liked: boolean;
    handleFavorite: (value: string, liked: boolean) => void;
    name?: string;
    onClickModal?: () => void;
    setTempFavorite(favorite: string): void;
}

export const FavoriteGenreStyles = tv({
    slots: {
        base: 'group click-area flex bg-gray-900 px-2 py-1 items-center gap-2',
    },
});

export const FavoriteGenre = ({
    id,
    name,
    liked,
    className,
    handleFavorite,
    setTempFavorite,
    onClickModal,
    testId = 'favorite-genre',
}: FavoriteGenreProps): JSX.Element => {
    const { base } = FavoriteGenreStyles();
    const { t } = useTranslation('global');

    const token = getCookie('userToken') as string | undefined;
    const [showLoginModal, setShowLoginModal] = useState(false);

    return (
        <div key={id} className={base({ className })} data-testid={testId}>
            <Like
                id={id}
                onClick={(value, liked) => {
                    if (token) {
                        handleFavorite(value, liked);
                    } else {
                        setTempFavorite(value);
                        setShowLoginModal(true);
                    }
                }}
                liked={liked}
            />
            <Text className="uppercase">{name}</Text>
            <Modal
                className="fixed top-0 z-50 flex w-screen justify-center backdrop-blur-2xl"
                isShown={showLoginModal}
                onClose={() => setShowLoginModal(false)}
            >
                <Modal.Header onClose={() => setShowLoginModal(false)} />
                <Modal.Content>
                    <div className="flex flex-col gap-4 p-4">
                        <Text className="text-center">
                            {t('loginToFavorite')}
                        </Text>
                        <Button onClick={onClickModal}>{t('login')}</Button>
                    </div>
                </Modal.Content>
            </Modal>
        </div>
    );
};
